import { render } from "./Footer.vue?vue&type=template&id=735e7384&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=735e7384&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-735e7384"

export default script